/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode {
    /**
     * Ссылка для погашения промокода.
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode
     */
    RedeemPromoCodeUrl: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode {
    if (!('RedeemPromoCodeUrl' in value) || value['RedeemPromoCodeUrl'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode {
    if (json == null) {
        return json;
    }
    return {
        
        'RedeemPromoCodeUrl': json['redeem_promo_code_url'],
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redeem_promo_code_url': value['RedeemPromoCodeUrl'],
    };
}

